import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    ownerType: String,
    ownerId: String
  }

  getContext() {
    return {
      ownerType: this.ownerTypeValue,
      ownerId: this.ownerIdValue
    }
  }

  changeContext(event) {
    const [ownerType, ownerId] = event.target.value.split("-")
    this.ownerTypeValue = ownerType
    this.ownerIdValue = ownerId
    console.log(`Switched to: ${ownerType} ${ownerId}`)
  }

  loadTasks(event) {
    event.preventDefault();
    const url = `/ai_tasks?owner_type=${this.ownerTypeValue}&owner_id=${this.ownerIdValue}`;
  
    event.currentTarget.setAttribute('href', url);
    Turbo.visit(url, { frame: "sidebar-body" });
  }
  

  copyTask(event) {
    const aiTaskId = event.currentTarget.dataset.aiTaskId;
    const { ownerType, ownerId } = this.getContext();
    const url = `/ai_tasks/${aiTaskId}/copy`;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token,
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html' // 👈 tell Rails we want a Turbo Stream response
      },
      body: JSON.stringify({
        owner_type: ownerType,
        owner_id: ownerId
      })
    }).then(response => {
      if (response.ok) {
        response.text().then(html => {
          Turbo.renderStreamMessage(html); // 👈 inject the Turbo Stream response into the page
        });
      }
    });
  }
   
  saveTask(event) {
    const button = event.currentTarget;
    const { ownerType, ownerId } = this.getContext();
  
    const messageText = button.dataset.aiTaskMessageTextValue;
    const searchEnabled = button.dataset.aiTaskSearchEnabledValue === "true";
    const thinkingEnabled = button.dataset.aiTaskThinkingEnabledValue === "true";
    const fileIds = button.dataset.aiTaskFileIdsValue.split(",").filter(Boolean);
    const threadId = button.dataset.aiTaskThreadIdValue;
  
    const url = `/ai_tasks`;
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token,
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html',
        'Turbo-Frame': 'save_task_btn'
      },
      body: JSON.stringify({
        ai_task: {
          prompt_message: messageText,
          owner_type: ownerType,
          owner_id: ownerId,
          search: searchEnabled,
          thinking: thinkingEnabled,
          file_ids: fileIds,
          thread_id: threadId
        }
      })
    }).then(response => {
      if (response.ok) {
        response.text().then(html => {
          Turbo.renderStreamMessage(html); // 👈 applies the Turbo Stream response
        });
      }
    });
  }
  
  
}
